import script from "./AppProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./AppProgress.vue?vue&type=script&setup=true&lang=js"

export default script